import type { CameraTask } from "@/domains/tasks/api/types";

const LIEN = {
  kind: "internal" as const,
  userId: "u-lien",
  name: "Lien Vandevelde",
};
const JEROEN = {
  kind: "partner" as const,
  userId: "u-jeroen",
  name: "Jeroen Vermeer",
};

export const SEED_TASKS: ReadonlyArray<CameraTask> = [
  // ───────── case-9214 — Plaatsing De Coninckplein ─────────
  {
    id: "tsk-9214-01",
    caseId: "case-9214",
    title: "Teams: Maak een mapje aan op Teams",
    category: "administration",
    status: "done",
    assignee: LIEN,
    dueDate: "2026-05-02",
    templateId: "tpl-placement",
  },
  {
    id: "tsk-9214-02",
    caseId: "case-9214",
    title: "Breng 802 in kennis via mail",
    category: "administration",
    status: "done",
    assignee: LIEN,
    dueDate: "2026-05-03",
    templateId: "tpl-placement",
  },
  {
    id: "tsk-9214-03",
    caseId: "case-9214",
    title: "Genetec: Configtool: Functionele naam instellen",
    category: "operations",
    status: "done",
    assignee: LIEN,
    dueDate: "2026-05-04",
    templateId: "tpl-placement",
  },
  {
    id: "tsk-9214-04",
    caseId: "case-9214",
    title: "Camera plaatsen op locatie",
    description: "MC-001 op De Coninckplein, kijkrichting noordwest.",
    category: "placement",
    status: "done",
    assignee: JEROEN,
    dueDate: "2026-05-05",
    templateId: "tpl-placement",
  },
  {
    id: "tsk-9214-05",
    caseId: "case-9214",
    title: "Eerste beeldcontrole",
    category: "operations",
    status: "inProgress",
    assignee: LIEN,
    dueDate: "2026-05-12",
    templateId: "tpl-placement",
  },
  {
    id: "tsk-9214-06",
    caseId: "case-9214",
    title: "Extra nachtelijke beeldcontrole — week 2",
    description: "Controle 22u-02u op verzoek wijkteam.",
    category: "operations",
    status: "todo",
    assignee: LIEN,
    dueDate: "2026-05-15",
    templateId: "tpl-custom",
  },
  {
    id: "tsk-9214-07",
    caseId: "case-9214",
    title: "Plaatsingsfirma briefen — ophaaldatum bevestigen",
    category: "external",
    status: "todo",
    assignee: JEROEN,
    dueDate: "2026-05-18",
    templateId: "tpl-pickup",
  },
  {
    id: "tsk-9214-08",
    caseId: "case-9214",
    title: "Camera ophalen na einde inzet",
    description: "MC-001 + BP-001 ophalen, terugbrengen naar depot.",
    category: "decommission",
    status: "todo",
    assignee: JEROEN,
    dueDate: "2026-05-19",
    reminderDate: "2026-05-18",
    templateId: "tpl-pickup",
  },

  // ───────── case-9221 — Plaatsing Groenplaats ─────────
  {
    id: "tsk-9221-01",
    caseId: "case-9221",
    title: "Teams: aanvraag en foto's opslaan",
    category: "administration",
    status: "done",
    assignee: LIEN,
    dueDate: "2026-05-05",
    templateId: "tpl-placement",
  },
  {
    id: "tsk-9221-02",
    caseId: "case-9221",
    title: "Doofplan: nakijken of activeren",
    category: "operations",
    status: "done",
    assignee: LIEN,
    dueDate: "2026-05-07",
    templateId: "tpl-placement",
  },
  {
    id: "tsk-9221-03",
    caseId: "case-9221",
    title: "Plaatsingsfirma briefen — plaatsdatum bevestigen",
    category: "external",
    status: "done",
    assignee: JEROEN,
    dueDate: "2026-05-07",
    templateId: "tpl-placement",
  },
  {
    id: "tsk-9221-04",
    caseId: "case-9221",
    title: "Camera plaatsen Groenplaats",
    category: "placement",
    status: "todo",
    assignee: JEROEN,
    dueDate: "2026-05-12",
    templateId: "tpl-placement",
  },
  {
    id: "tsk-9221-05",
    caseId: "case-9221",
    title: "Contact festivalorganisator 'Stad in Beweging'",
    description: "Coördinatie inzet camera met security-team festival.",
    category: "external",
    status: "todo",
    assignee: LIEN,
    dueDate: "2026-05-09",
    templateId: "tpl-custom",
  },

  // ───────── case-9223 — Sint-Jansvliet (plaatsing + verplaatsing mid-period) ─────────
  {
    id: "tsk-9223-01",
    caseId: "case-9223",
    title: "Teams: mapje aanmaken voor dossier",
    category: "administration",
    status: "done",
    assignee: LIEN,
    dueDate: "2026-05-01",
    templateId: "tpl-placement",
  },
  {
    id: "tsk-9223-02",
    caseId: "case-9223",
    title: "Camera plaatsen Sint-Jansvliet 19",
    description: "MC-008 tegenover Brouwershuis, kijkrichting noordoost.",
    category: "placement",
    status: "done",
    assignee: JEROEN,
    dueDate: "2026-05-04",
    templateId: "tpl-placement",
  },
  {
    id: "tsk-9223-03",
    caseId: "case-9223",
    title: "Eerste beeldcontrole",
    category: "operations",
    status: "done",
    assignee: LIEN,
    dueDate: "2026-05-05",
    templateId: "tpl-placement",
  },
  {
    id: "tsk-9223-04",
    caseId: "case-9223",
    title: "Teams: mapje vorige locatie naar archief",
    description: "Verplaatsing naar Sint-Jansvliet 35 — admin voorbereiden.",
    category: "administration",
    status: "done",
    assignee: LIEN,
    dueDate: "2026-05-09",
    templateId: "tpl-relocation",
  },
  {
    id: "tsk-9223-05",
    caseId: "case-9223",
    title: "Plaatsingsfirma briefen — verplaatsing naar nr. 35",
    category: "external",
    status: "inProgress",
    assignee: JEROEN,
    dueDate: "2026-05-11",
    templateId: "tpl-relocation",
  },
  {
    id: "tsk-9223-06",
    caseId: "case-9223",
    title: "Camera ophalen Sint-Jansvliet 19",
    category: "decommission",
    status: "todo",
    assignee: JEROEN,
    dueDate: "2026-05-12",
    templateId: "tpl-relocation",
  },
  {
    id: "tsk-9223-07",
    caseId: "case-9223",
    title: "Camera plaatsen Sint-Jansvliet 35",
    description: "Heropstellen op zicht richting Pelgrimstraat.",
    category: "placement",
    status: "todo",
    assignee: JEROEN,
    dueDate: "2026-05-12",
    templateId: "tpl-relocation",
  },
  {
    id: "tsk-9223-08",
    caseId: "case-9223",
    title: "Kijkrichting nakijken op nieuwe locatie",
    category: "placement",
    status: "todo",
    assignee: JEROEN,
    dueDate: "2026-05-12",
    templateId: "tpl-relocation",
  },

  // ───────── case-9225 — Mobile tree Operaplein ─────────
  {
    id: "tsk-9225-01",
    caseId: "case-9225",
    title: "Mobile tree opzetten Operaplein",
    category: "placement",
    status: "todo",
    assignee: JEROEN,
    dueDate: "2026-05-11",
    templateId: "tpl-placement",
  },
  {
    id: "tsk-9225-02",
    caseId: "case-9225",
    title: "Genetec functionele naam: MT-Operaplein",
    category: "operations",
    status: "todo",
    assignee: LIEN,
    dueDate: "2026-05-11",
    templateId: "tpl-placement",
  },
  {
    id: "tsk-9225-03",
    caseId: "case-9225",
    title: "Coördineren met Sinksenfoor-organisatie",
    description: "Praktische afspraken over plaatsing en stroomtoevoer.",
    category: "external",
    status: "done",
    assignee: LIEN,
    dueDate: "2026-05-08",
    templateId: "tpl-custom",
  },

  // ───────── case-9227 — Camcar Sportpaleis ─────────
  {
    id: "tsk-9227-01",
    caseId: "case-9227",
    title: "Plaatsingsfirma briefen — concertavonden",
    category: "external",
    status: "done",
    assignee: JEROEN,
    dueDate: "2026-05-10",
    templateId: "tpl-placement",
  },
  {
    id: "tsk-9227-02",
    caseId: "case-9227",
    title: "Plaatsing camcar Sportpaleis",
    category: "placement",
    status: "todo",
    assignee: JEROEN,
    dueDate: "2026-05-11",
    reminderDate: "2026-05-10",
    templateId: "tpl-placement",
  },
  {
    id: "tsk-9227-03",
    caseId: "case-9227",
    title: "Camera ophalen na concertreeks",
    category: "decommission",
    status: "todo",
    assignee: JEROEN,
    dueDate: "2026-05-13",
    templateId: "tpl-pickup",
  },

  // ───────── case-9229 — ANPR-trailer Singel ─────────
  {
    id: "tsk-9229-01",
    caseId: "case-9229",
    title: "Signalisatieplan indienen dienst mobiliteit",
    category: "administration",
    status: "done",
    assignee: LIEN,
    dueDate: "2026-04-29",
    templateId: "tpl-custom",
  },
  {
    id: "tsk-9229-02",
    caseId: "case-9229",
    title: "ANPR data uitlezen Singel",
    category: "operations",
    status: "inProgress",
    assignee: LIEN,
    dueDate: "2026-05-13",
    templateId: "tpl-custom",
  },
  {
    id: "tsk-9229-03",
    caseId: "case-9229",
    title: "Tussentijdse evaluatie ANPR-resultaten",
    description: "Rapport voor dienst mobiliteit — mid-deployment review.",
    category: "operations",
    status: "todo",
    assignee: LIEN,
    dueDate: "2026-05-14",
    templateId: "tpl-custom",
  },
  {
    id: "tsk-9229-04",
    caseId: "case-9229",
    title: "Preventief onderhoud ANPR-trailer TR-001",
    description: "Kalibratie sensoren en update firmware vóór einde inzet.",
    category: "operations",
    status: "todo",
    assignee: JEROEN,
    dueDate: "2026-05-13",
    templateId: "tpl-maintenance",
  },

  // ───────── case-9214 — tussentijds onderhoud op batterij pack ─────────
  {
    id: "tsk-9214-09",
    caseId: "case-9214",
    title: "Defect BP-001 documenteren — laadcapaciteit < 50%",
    description: "Tijdens beeldcontrole vastgesteld dat batterij pack vroegtijdig leeg loopt.",
    category: "administration",
    status: "done",
    assignee: LIEN,
    dueDate: "2026-05-08",
    templateId: "tpl-maintenance",
  },
  {
    id: "tsk-9214-10",
    caseId: "case-9214",
    title: "Vervang BP-001 — herstelling onder garantie",
    category: "operations",
    status: "inProgress",
    assignee: JEROEN,
    dueDate: "2026-05-11",
    templateId: "tpl-maintenance",
  },

  // ───────── case-9199 — Afgerond Park Spoor Noord (volledige ophaling) ─────────
  {
    id: "tsk-9199-01",
    caseId: "case-9199",
    title: "Plaatsingsfirma briefen — ophaaldatum bevestigen",
    category: "external",
    status: "done",
    assignee: JEROEN,
    dueDate: "2026-04-07",
    templateId: "tpl-pickup",
  },
  {
    id: "tsk-9199-02",
    caseId: "case-9199",
    title: "Camera ophalen Park Spoor Noord",
    category: "decommission",
    status: "done",
    assignee: JEROEN,
    dueDate: "2026-04-08",
    templateId: "tpl-pickup",
  },
  {
    id: "tsk-9199-03",
    caseId: "case-9199",
    title: "Genetec: functionele naam terug naar default",
    category: "operations",
    status: "done",
    assignee: LIEN,
    dueDate: "2026-04-09",
    templateId: "tpl-pickup",
  },
  {
    id: "tsk-9199-04",
    caseId: "case-9199",
    title: "Excel 'camerabeheer' bijwerken — einde inzet",
    category: "administration",
    status: "done",
    assignee: LIEN,
    dueDate: "2026-04-09",
    templateId: "tpl-pickup",
  },
  {
    id: "tsk-9199-05",
    caseId: "case-9199",
    title: "Dossier afsluiten en archiveren",
    category: "administration",
    status: "done",
    assignee: LIEN,
    dueDate: "2026-04-09",
    templateId: "tpl-pickup",
  },
];
